import { render, staticRenderFns } from "./MessageBlocks.vue?vue&type=template&id=2a24ce12&scoped=true"
import script from "./MessageBlocks.vue?vue&type=script&lang=js"
export * from "./MessageBlocks.vue?vue&type=script&lang=js"
import style0 from "./MessageBlocks.vue?vue&type=style&index=0&id=2a24ce12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a24ce12",
  null
  
)

export default component.exports